const StripeTerminal = window.StripeTerminal || { create: () => {} };
export default StripeTerminal;


// WEBPACK FOOTER //
// ./src/extension/stripe-terminal-payment/service/payment/type/stripeterminal/sdk.js